<template>
  <div class="pageContainer app-container">
    <el-row class="">
      <!-- <el-popconfirm width="250" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info" iconColor="red" @confirm="mutiDel"
       title="是否确定删除？">
        <el-button slot="reference" size="small" icon="el-icon-delete" type="danger" style="margin-left: 10px;">
          删除
        </el-button>
      </el-popconfirm> -->
    </el-row>
    <el-row type="flex" style="margin: 20px 0;" justify="start">
      <el-tabs v-model="activeName" type="border-card" style="width: 100%">
        <el-tab-pane v-for="item in tabMapOptions"
                     :key="item.key"
                     :label="item.label"
                     :name="item.key"
        >
          <el-table :data="tableData"
                    row-key="id"
                    border
                    :span-method="objectSpanMethod"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    show-summary
          >
            style="width: 100%;margin-bottom: 20px;" border stripe>
            <el-table-column prop="item_desc" label="学制"></el-table-column>
            <el-table-column prop="major_name" label="专业"></el-table-column>
            <el-table-column prop="class_name" label="班级"></el-table-column>
            <el-table-column prop="report_num" label="报到人数"></el-table-column>
            <el-table-column prop="no_report_num" label="未报到人数"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>
<script>
import api from '@/api/api';

export default {
  name: 'statistics',
  data() {
    return {
      searchForm: {
        ktype: 'stu_name',
      }, //查询
      //dialog
      visible: false,
      isShowModal: false,
      isShowRole: false,
      updDialog: false,
      modalTitle: '添加',
      formData: {},
      //table
      tabMapOptions: [{
        label: '报到统计',
        key: 'CN'
      },],
      activeName: 'CN',
      tableData: [],
      page: {
        pageIndex: 1,
        pageSize: 20,
        total: 0
      },
      colFields: [
        "item_desc",
        "major_name",
        "class_name",
        "report_num",
        "no_report_num"
      ],
      spanArr: []
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    //table
    getList() {
      this.$http.post('/api/stu_report_statistics', {}).then(res => {
        this.tableData = res.data
        for (let i = 0; i < this.tableData.length; i++) {
          let row = i;
          // let col = i % this.colCount;
          if (row === 0) {
            // i 表示行 j表示列
            for (let j = 0; j < this.colFields.length; j++) {
              this.spanArr[i * this.colFields.length + j] = {
                rowspan: 1,
                colspan: 1,
              };
            }
          } else {
            for (let j = 0; j < this.colFields.length; j++) {
              // 当前和上一次的一样
              // 1. 合并所有列的相同数据单元格
              if (this.colFields[j] === 'item_desc' || this.colFields[j] === 'major_name') {
                if (
                    this.tableData[row][this.colFields[j]] ===
                    this.tableData[row - 1][this.colFields[j]]
                ) {
                  let beforeItem =
                      this.spanArr[(row - 1) * this.colFields.length + j];
                  this.spanArr[row * this.colFields.length + j] = {
                    rowspan: 1 + beforeItem.rowspan, // 合并几行
                    colspan: 1, // 合并几列,我这里只是跨行合并,不跨列合并,所以用的1
                  };
                  beforeItem.rowspan = 0;
                  beforeItem.colspan = 0;
                } else {
                  // rowspan 和 colspan 都为1表格此单元格不合并
                  this.spanArr[row * this.colFields.length + j] = {
                    rowspan: 1,
                    colspan: 1,
                  };
                }
              }
            }
          }
        }
        // 对数据进行倒序
        let stack = [];
        for (let i = 0; i < this.colFields.length; i++) {
          for (let j = 0; j < this.tableData.length; j++) {
            // console.log("i=" + i + " j=" + j);
            // i 表示列 j表示行
            if (j === 0) {
              if (this.spanArr[j * this.colFields.length + i].rowspan === 0) {
                stack.push(this.spanArr[j * this.colFields.length + i]);
              }
            } else {
              if (this.spanArr[j * this.colFields.length + i] !== undefined && this.spanArr[j * this.colFields.length + i].rowspan === 0) {
                stack.push(this.spanArr[j * this.colFields.length + i]);
              } else {
                stack.push(this.spanArr[j * this.colFields.length + i]);
                while (stack.length > 0) {
                  let pop = stack.pop();
                  let len = stack.length;
                  this.spanArr[(j - len) * this.colFields.length + i] = pop;
                }
              }
            }
          }
        }
      })
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      // console.log(this.spanArr[rowIndex * this.colFields.length + columnIndex]);
      return this.spanArr[rowIndex * this.colFields.length + columnIndex];
    },
  }
}
</script>

<style scoped lang="less" type="text/less">
.app-container {
  .treeContainer {
    height: 100%;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
    border: 1px solid rgba(220, 223, 230, 0.6);

    .treeTitle {
      height: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #409eff;
      padding-left: 6px;
    }
  }

  .roleitem {
    display: inline-block;
    padding: 1px 5px;
    font-size: 12px;
    background-color: #00B0E8;
    color: #fff;
    margin-right: 5px;
    margin-bottom: 5px;
    border-radius: 2px;
  }
}
</style>
